import type { ContactFormData, ContactFormErrors } from './types';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function validateForm(
  data: ContactFormData,
  errorMessages: { emptyField: string; invalidEmail: string },
): ContactFormErrors {
  const errors: ContactFormErrors = {};

  if (!data.name.trim()) {
    errors.name = errorMessages.emptyField;
  }

  if (!data.email.trim()) {
    errors.email = errorMessages.emptyField;
  } else if (!isValidEmail(data.email)) {
    errors.email = errorMessages.invalidEmail;
  }

  if (!data.reason) {
    errors.reason = errorMessages.emptyField;
  }

  if (!data.message.trim()) {
    errors.message = errorMessages.emptyField;
  }

  return errors;
}

export function hasErrors(errors: ContactFormErrors): boolean {
  return Object.values(errors).some(Boolean);
}
